<template>
  <form @submit.prevent action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Editar Informações da Conta</p>
      </header>

      <section class="modal-card-body">
        <div class="tile is-ancestor">
          <div class="tile is-vertical">
            <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Nome da Conta">
                    <b-input
                      placeholder="Ex.: Conta Bancária"
                      v-model="conta.nome"
                      :disabled="conta.isDefault"
                    ></b-input>
                  </b-field>
                </article>
              </div>

              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Data de Abertura">
                    <b-datepicker
                      v-model="conta.data_criacao"
                      placeholder="Clique para selecionar..."
                      icon="calendar-today"
                      position="is-top-left"
                      :month-names="monthNames"
                      :day-names="dayNames"
                      :disabled="conta.isDefault"
                    ></b-datepicker>
                  </b-field>
                </article>
              </div>
            </div>
          </div>
        </div>

        <div class="tile is-ancestor">
          <div class="tile is-vertical">
            <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Saldo Atual">
                    <money
                      v-model="conta.saldo"
                      v-bind="money"
                      class="input form-input input-lg"
                      style="border-color: #ffdd57;"
                    >{{conta.saldo}}</money>
                  </b-field>
                </article>
              </div>

              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Saldo Inicial">
                    <money
                      v-model="conta.saldo_inicial"
                      v-bind="money"
                      class="input form-input input-lg"
                    >{{conta.saldo_anterior}}</money>
                  </b-field>
                </article>
              </div>
            </div>
          </div>
        </div>

        <b-notification type="is-warning" style="max-width: 450px; margin: 0 auto;">
          <p>Alterar o <strong>Saldo Atual</strong> é desaconselhado, pois pode gerar inconsistência
          entre o saldo e as transações da conta. Se a alteração for feita, uma transação de ajuste será gerada automaticamente.</p>
        </b-notification>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success is-small" @click="saveAccount()">Salvar Informações</button>
        <button class="button is-danger is-small" @click="closeModal()">Cancelar</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  props: ["account"],
  data() {
    return {
      conta: {
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _id: this.account._id,
        data_atualizacao: new Date(),
        data_criacao: new Date(this.account.data_criacao.seconds*1000),
        isActive: this.account.isActive,
        isDefault: this.account.isDefault,
        nome: this.account.nome,
        saldo: this.account.saldo,
        saldo_inicial: this.account.saldo_inicial
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " #",
        precision: 2,
        masked: false
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      dayNames: ["D", "S", "T", "Q", "Q", "S", "S"]
    };
  },
  computed: {
    successUpdateConta() {
      return this.$store.getters["contas/getIsSuccess"];
    },

    successAddTransacao() {
      return this.$store.getters["transacao/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    validateAccount() {
      if (!this.conta.nome.trim()) return "Adicione um Nome à Conta!";
      if (!this.conta.data_criacao) return "Adicione uma Data de Abertura!";
      return;
    },

    saveAccount() {
      let error = this.validateAccount();
      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }
      this.closeModal();
      this.saveAccountOnDatabase();
    },

    async saveAccountOnDatabase() {
      const loadingComponent = this.$loading.open({
        container: null
      });

      if (this.conta.isDefault) {
        delete this.conta["nome"];
        delete this.conta["data_criacao"]
        delete this.conta["isActive"]
        delete this.conta["isDefault"]
      } else {
        this.account["nome"] = this.conta["nome"];
      }

      //Verifica-se se houve alteração no saldo atual
      let transacao;
      if (this.conta.saldo !== this.account.saldo)
        transacao = this.gerarTransacaoAjuste();

      //Verifica se houve alteração no saldo inicial
      let novoSaldoInicial;
      if (this.conta.saldo_inicial !== this.account.saldo_inicial) {
        novoSaldoInicial = this.conta["saldo_inicial"] - this.account["saldo_inicial"];
        novoSaldoInicial = parseFloat(novoSaldoInicial.toFixed(2));
      }

      if ((transacao && novoSaldoInicial) || novoSaldoInicial) {
        let newSaldo = this.account["saldo"] + novoSaldoInicial
        this.conta["saldo"] = parseFloat(newSaldo.toFixed(2));
        this.account["saldo"] = this.conta["saldo"];
        this.account["saldo_inicial"] += novoSaldoInicial;
        this.account["saldo_inicial"] = parseFloat(this.account["saldo_inicial"].toFixed(2));
      } else if (transacao)
        this.conta["saldo"] = this.account["saldo"];

      await this.$store.dispatch("contas/updateContaInFirestore", this.conta);

      if (transacao) {
        await this.$store.dispatch("transacao/saveTransacaoInFirestore", transacao);
        this.account.saldo += transacao.valor;
        this.account.saldo = parseFloat(this.account.saldo.toFixed(2));
      } else
        this.$store.dispatch("transacao/getTransacoesInFirestore");

      loadingComponent.close();

      if (this.successUpdateConta)
        this.$alert("Sucesso!", "Conta Alterada!", "success");
      else
        this.$alert("Erro!", "Erro ao Alterar a Conta!", "danger");

      if (this.successAddTransacao && transacao)
        this.$alert("Sucesso!", "Transação de Ajuste Criada!", "success");

      this.$store.commit("contas/setIsSuccess", false);
      this.$store.commit("transacao/setIsSuccess", false);
    },

    gerarTransacaoAjuste() {
      let transacao = {
        _id: this.stringRandomId(20),
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _conta: this.conta["_id"],
        _responsavel: this.$cookies.get("USERTOKEN"),
        data: new Date(),
        valor: 0.0,
        tipo: "Ajuste de Conta",
        descricao: "Transação de Ajuste de Saldo",
        allowedErase: true,
        isAdjust: true
      }
      let newValue = this.conta["saldo"] - this.account["saldo"]
      transacao["valor"] = parseFloat(newValue.toFixed(2));
      return transacao;
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    }
  },
  mounted() {}
};
</script>

<style scoped>
@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>
